import { useState, useContext, useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../../Context";
import { BsPencil, BsThreeDotsVertical } from "react-icons/bs";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { MdOutlineArrowLeft } from "react-icons/md";
import { LuSheet } from "react-icons/lu";


import { Loader, GET } from "../../../inc/Fetch"; 
import { ClassesDropdown } from "../../../components/Form"; 

import Task from "./Task"; 

import './css/Teacher_tasks.css'

export default function Teachers_tasks() {

    const { t } = useTranslation();
    const location = useLocation();

    const { successData, userData } = useContext(AppContext);
    // const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [data, setdata] = useState({})
    const [isLoading, setisLoading] = useState(true)
    const [filter, setfilter] = useState({})
    const [openOptions, setopenOptions] = useState(false)

    async function loadData() {
        let r = await GET(`task/myTasks`);
        setisLoading(false);
        setdata(r);
    }

    // const { data, error, isLoading, refetch } = useQuery(`myTasks`, loadData); 

    

    useEffect(() => {
        loadData();
    }, [window.location.pathname]);

    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://teams.microsoft.com/share/launcher.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);
        }
    }, []);
    
    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://apis.google.com/js/platform.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);

            window.___gcfg = {
                parsetags: 'onload'
            };
        }
    }, []);
    
    if (isLoading) {
        return  <Loader />;
    }

    if (userinfo?.userlevel < 3) {
        return <Permission />
    }

    
    

    return (
        <div className='teacherTaskBox'>
            
            <div className='mainWidth shadow' style={{maxWidth:900}}>

                <nav className='breadcrumbs'>
                    <Link to={`/`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("header_user_menu_2")}</Link>
                
                </nav>

                <div className='mainMyTasksTitleBox'>
                    <h1 className='mainTitle'>{t("header_user_menu_2")}</h1>
                    <nav>
                        <a onClick={() => setopenOptions(p => !p)} className='mainClick'><BsThreeDotsVertical /></a>
                        {openOptions && <ul>
                            <Link target='_blank' to='/AllTaskStatsDownload'><LuSheet /> {t("tasks_menu_8")}</Link>
                        </ul>}
                    </nav>
                </div>
                
                <div className='tasksStatsBox ' >

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats?.length ? data?.stats[0] : 0}</b>
                            <span>{t("tasks_stats_1")}</span>
                        </p>
                        <PiPencil />
                    </div>
                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[1]}</b>
                            <span>{t("tasks_stats_2")}</span>
                        </p>
                        <PiBuildingsLight />
                    </div>
                    <div>
                        <hr />
                        <p>
                            <b>{data?.stats[2]}</b>
                            <span>{t("tasks_stats_3")}</span>
                        </p>
                        <PiStudent />
                    </div>

                </div>


                <div className='filterBox'>
                    <div>
                        {t("tasks_tasks_count")} ({data?.tasks_num})
                    </div>
                    <form>
                        <input 
                            className='searchInput' 
                            type="search" 
                            placeholder={`${t("search")}..`} 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                text:d?.target?.value
                            }))}
                        />

                        <select className='searchInput' style={{maxWidth:180}}
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                classes:d?.target?.value
                            }))}
                        >
                            <option value=''>- {t("classes")} -</option>
                            {userinfo?.classes?.map((v, k) => {
                                let cls = v?.split("-")[0];
                                let grd = v?.split("-")[1];
                                
                                return (
                                    <option key={k} value={v}>{`${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`}</option>
                                );
                                // Cls.push({name: `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`, val:`${cls}-${grd}`});
                            })}
                        </select>
                    </form>
                </div>

                <div className='myTaskBody'>
                            
                    {data.tasks?.map((v, k) => {

                        let checkClasses = filter?.classes ? false : true;
                        if (v?.classes == filter?.classes) {
                            checkClasses = true;
                            
                        }
                        
                        if (checkClasses) {

                            let cls = v?.classes?.split("-")[0];
                            let grd = v?.classes?.split("-")[1];
    
                            let className = `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`;
                            return (
                                <div key={k} className='taskClassesSection'>
                                    
                                    <strong className='taskClassesTitle'>{className}</strong>
    
                                    {v?.data?.map((vv, kk) => {
    
                                        let view = filter?.text ? false : true;
                                        if (vv?.title.indexOf(filter?.text) > -1) {
                                            // console.log(filter?.text);
                                            view = true;
                                        }
                                        
                                        
                                        let studentsAnswers = data?.answers?.filter(r => r?.task?._id == vv?._id);
                                        vv.answersQnt = studentsAnswers?.length;
                                        
                                        if (view) {
                                            
                                            return (
                                                <Task v={vv} key={kk} />
                                            );
                                        }
                                    })}
    
                                    
                            
                                </div>
                            );
                        }
                        

                        
                    })}

                    {!data.tasks?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}

                </div>

                

            </div>


        </div>
    )
}
